







































































































































































































































import CustomerUser from "@/model/customerUser";
import "flatpickr/dist/flatpickr.css";
import "vue-loading-overlay/dist/vue-loading.css";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const auth = namespace("Auth");
import { LANG } from "@/common/constant";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);

@Component({
  name: "NaritaKoiLayout",
})
export default class NaritaKoiLayout extends Vue {
  @auth.Getter
  public isCustomer!: boolean;
  @auth.Getter
  public getCustomerUser!: CustomerUser;

  @auth.Getter
  public isLoginTime!: boolean;

  @auth.Action
  public updateIsLoginTime!: (isLoginTime: boolean) => void;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public mounted() {
    if (this.isCustomer && this.getCustomerUser.is_changed_password == false) {
      this.updateIsLoginTime(false);
    }
  }

  public setLanguage(lang = "ja") {
    if (lang == "ja") {
      return this.$route.path;
    }
    return this.$route.path + `?lang=${lang}`;
  }

  public selectLang(lang = "ja") {
    if (this.$route.query.lang) {
      return this.$route.query.lang == lang ? "on" : "";
    } else {
      return lang == LANG.JA ? "on" : "";
    }
  }
}
